export type SubscriptionTier = "free" | "premium";

export interface SubscriptionState {
  tier: SubscriptionTier;
  expiresAt: number | null;
  stripeCustomerId: string | null;
}

export type PremiumFeature =
  | "custom_background_image"
  | "all_bible_translations"
  | "verse_of_the_day"
  | "remove_branding";

export const PREMIUM_FEATURES: Record<
  PremiumFeature,
  { name: string; description: string }
> = {
  custom_background_image: {
    name: "Custom Backgrounds",
    description: "Upload your own images as backgrounds",
  },
  all_bible_translations: {
    name: "All Bible Translations",
    description: "Access 30+ Bible translations worldwide",
  },
  verse_of_the_day: {
    name: "Verse of the Day",
    description: "Receive curated daily verses",
  },
  remove_branding: {
    name: "Remove Branding",
    description: "Clean, distraction-free experience",
  },
};

export const PRICING = {
  monthly: { amount: 4, currency: "USD", interval: "month" as const },
  yearly: { amount: 36, currency: "USD", interval: "year" as const },
};
